import moment from 'moment';
import 'moment/locale/pt';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import starIcon from '../../../../assets/medico-online/Star.png';
import starEmptyOpacity from '../../../../assets/medico-online/star-empty-opacity.png';
import starFullOpacity from '../../../../assets/medico-online/star-full-opacity.png';
import starEmptyBorder from '../../../../assets/star-empty-border.png';
import noPhotoDoctor from '../../../../assets/medico_sem_foto.png';
import Icon from '../../../../components/icon';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import {Icons} from '../../../../util/icons';
import {strings} from '../../../../util/strings';
import {
  possibleAppointmentStatus,
} from '../../../../util/utility';
import AppointmentDetails from '../../../appointment-details';
import AppointmentWarningPopup from '../../../appointment-warning-popup';
import './styles.scss';
import {Rating} from '@mui/material';
import CameraIcon from './assets/CameraIcon';
import CameraAppointmentDoneIcon from './assets/CameraAppointmentDoneIcon';
import CameraAppointmentConfirmedIcon from './assets/CameraAppointmentConfirmedIcon';
import {get} from '../../../../api/api';
import {uriGetAppointment} from '../../../../api/endpoints';
import ModalTemplate from '../../../../components/modal';
import AppButton from '../../../../components/app-button';
import {setWizard} from '../../../../store/actions';

export interface AppointmentListItemProps {
  buStyles: any;
  appointmentItem: any;
  labels: typeof strings.pt.appointments;
  borderColor?: any;
  setRefresh(value: any): void;
  setWizard: Function;
}

function AppointmentListItem({
  appointmentItem,
  buStyles,
  labels,
  borderColor,
  setRefresh,
  setWizard,
}: AppointmentListItemProps) {
  const {
    BOOKED,
    PORPOSED,
    CHECKEDIN,
    PENDING,
    FULLFILED,
    NOSHOW,
    CANCELLED,
    DECLINED,
  } = possibleAppointmentStatus;
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [appointmentClick, setAppointmentClick] = useState(false);
  const [appointmentStartError, setAppointmentStartError] = useState(false);

  const fifteenLeft = moment(appointmentItem.startTime).subtract(15, 'minutes');
  const betweenFifteen = moment(new Date()).isAfter(fifteenLeft);
  const appointmentConfirmed =
    (appointmentItem.status === BOOKED &&
      !moment(new Date()).isAfter(fifteenLeft)) ||
    (appointmentItem.status === PORPOSED &&
      !moment(new Date()).isAfter(fifteenLeft));
  const appointmentStart =
    (appointmentItem.status === BOOKED && betweenFifteen) ||
    (appointmentItem.status === PORPOSED && betweenFifteen) ||
    appointmentItem.status === CHECKEDIN;
  const appointmentPending = appointmentItem.status === PENDING;
  const appointmentCanceled =
    appointmentItem.status === DECLINED || appointmentItem.status === CANCELLED;
  const appointmentDone =
    appointmentItem.status === FULLFILED || appointmentItem.status === NOSHOW;

  const appointmentDate =
    appointmentItem.startTime && moment(appointmentItem.startTime);

  const today = new Date();
  const isAppointmentToday = moment(appointmentDate).isSame(today, 'day');

  const tomorrow = moment(today).add(1, 'days');
  const isAppointmentTomorrow = moment(appointmentDate).isSame(tomorrow, 'day');

  useEffect(() => {
    setWizard({});
  }, []);

  const renderDate = (date: any) => {
    if (!isAppointmentToday && !isAppointmentTomorrow) {
      return (
        <>
          <Row className="date-row1">
            <span style={{...fonts.SM, ...fonts.Bold}}>
              {moment(date).format('DD MMM')}
            </span>
          </Row>
          <Row className="date-row2">
            <span style={{...fonts.SM}}>
              {moment(date).format('YYYY')}
            </span>
          </Row>
        </>
      );
    } else if (isAppointmentToday) {
      return (
        <span
          style={{...fonts.SM, ...fonts.Bold}}
          className="appointment-today">
          {labels?.appointments_today}
        </span>
      );
    } else if (isAppointmentTomorrow) {
      return (
        <span style={{...fonts.SM, ...fonts.Bold}}>
          {labels?.appointments_tomorrow}
        </span>
      );
    }
  };

  const renderEndedDate = (date: any) => {
    return (
      <div className="date-container">
        <Row className="date-row1">
          <span style={{...fonts.S}}>
            {labels?.appointments_finished_short}
          </span>
        </Row>
        <Row className="date-row2">
          <span className="date-row2-text" style={{...fonts.SM, ...fonts.SemiBold}}>
            {moment(date).format('DD MMM')}
          </span>
        </Row>
      </div>
    );
  };

  const handleStartAppointment = async () => {
    try {
      await get(uriGetAppointment(appointmentItem.id)).then((res: any) => {
        window.open(res.data.link, '_blank')?.focus();
      });
    } catch {
      setAppointmentStartError(true);
    }
  };

  const loadNoPhotoDoctor = (event: any) => {
    event.target.src = noPhotoDoctor;
  };

  const itemOnClick = () => {
    setAppointmentClick(true);
    const status = appointmentItem.status;
    switch (status) {
      case PENDING:
      case CANCELLED:
      case DECLINED:
        setShowWarningModal(true);
        setShowDetailsModal(false);
        break;
      default:
        setShowDetailsModal(true);
        setShowWarningModal(false);
        break;
    }
  };

  const renderModalAndPopups = () => {
    return (
      <>
        <AppointmentWarningPopup
          showModal={showWarningModal}
          setShowModal={setShowWarningModal}
          selectedAppointmentId={appointmentItem.id}
          status={appointmentItem.status}
          setRefresh={setRefresh}
          handleStartAppointment={handleStartAppointment}
        />
        <AppointmentDetails
          showDetailsModal={showDetailsModal}
          setShowDetailsModal={setShowDetailsModal}
          selectedAppointmentId={appointmentItem.id}
          borderColor={borderColor}
          setRefresh={setRefresh}
          handleStartAppointment={handleStartAppointment}
        />
      </>
    );
  };

  const textColor = {
    color: appointmentCanceled ? colors.darkGrey : buStyles.primaryColor,
  };
  const specialityColor = {
    color: appointmentCanceled ? colors.darkGrey : colors.black,
  };

  return (
    <>
      <Row
        className="homepage-margin-bottom"
        onClick={() => {
          itemOnClick();
        }}>
        <Column className="appointment-column1" style={{...fonts.MM}}>
          <img
            src={appointmentItem.doctor.photo.normal}
            onError={loadNoPhotoDoctor}
            className="doctor-img"
            style={{border: `1px solid ${borderColor}`}}
          />
        </Column>
        <Column className="appointment-column2">
          <span style={{...fonts.M, ...fonts.SemiBold, ...textColor}}>
            {appointmentItem.doctorName}
          </span>
          <span style={{...fonts.SM, ...specialityColor}}>
            {appointmentItem.doctor.specialties[0].name}
          </span>
          <Rating
            defaultValue={
              parseFloat(
                appointmentItem.doctor.rating
                  ? appointmentItem.doctor.rating
                  : 0
              ) / 2
            }
            precision={0.01}
            readOnly
            icon={
              <img
                src={appointmentCanceled ? starFullOpacity : starIcon}
                width={10}
              />
            }
            emptyIcon={
              <img
                src={appointmentCanceled ? starEmptyOpacity : starEmptyBorder}
                width={10}
              />
            }
          />
        </Column>
        {appointmentConfirmed && (
          <Column className="reimbursement-history-declarationlist-column3">
            <Column className="camera-icon-column">
              <CameraAppointmentConfirmedIcon />
            </Column>
            <Column className="appointment-date-time-container">
              {renderDate(appointmentItem.startTime)}
              <Row
                className={
                  isAppointmentToday || isAppointmentTomorrow
                    ? 'time-left-row-no-space'
                    : 'time-left-row'
                }>
                <div
                  style={{backgroundColor: buStyles.primaryColor}}
                  className="time-left-container">
                  <span
                    style={{...fonts.SM, ...fonts.SemiBold}}
                    className="time-left-text">
                    {moment(appointmentItem.startTime).format('HH:mm')}
                  </span>
                </div>
              </Row>
            </Column>
          </Column>
        )}
        {appointmentStart && (
          <Column className="reimbursement-history-declarationlist-column3">
            <Row onClick={() => handleStartAppointment()}>
              <CameraIcon />
            </Row>
          </Column>
        )}
        {(appointmentPending || appointmentCanceled) && (
          <Column className="reimbursement-history-declarationlist-column3-pending">
            <Row>
              <Icon
                width="15.5"
                height="15.5"
                color={colors.alertRed}
                name={Icons.ALERT_PROBLEM}
                changeViewbox 
                viewBox={'0 0 24 24'}
              />
            </Row>
            <Row
              className={
                appointmentPending ? 'pending-text-row' : 'cancelled-text-row'
              }>
              {appointmentPending && (
                <span
                  className="pending-text"
                  style={{...fonts.SM, color: colors.alertRed}}>
                  {labels?.appointments_pending_payment}
                </span>
              )}
              {appointmentCanceled && (
                <span
                  className="cancelled-text"
                  style={{...fonts.SM, color: colors.alertRed}}>
                  {labels?.appointments_cancelled}
                </span>
              )}
            </Row>
          </Column>
        )}
        {appointmentDone && (
          <Column className="ended-appointment-column">
            <Row className="column3-row1-ended">
              <CameraAppointmentDoneIcon />
              {renderEndedDate(appointmentItem.startTime)}
            </Row>
            <Row className="time-ended-row">
              <div className="time-ended-container">
                <span
                  style={{...fonts.SM, ...fonts.Medium}}
                  className="time-ended-text">
                  {moment(appointmentItem.startTime).format('HH:mm')}
                </span>
              </div>
            </Row>
          </Column>
        )}
      </Row>
      <div className="reimbursement-history-declarationlist-line"></div>
      {appointmentClick && renderModalAndPopups()}
      <ModalTemplate
        className="appointment-starting-error-modal"
        inputType="confirm"
        show={appointmentStartError}
        onHide={() => {
          setAppointmentStartError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox 
              viewBox={'0 0 24 24'}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
              className="p-errorPopup">
              {labels?.appointments_error}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                setAppointmentStartError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
    </>
  );
}

const mapStateToProps = ({globalStyles, strings}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentListItem)
);
